import { RehearsalSceneRequestDto } from './RehearsalSceneRequestDTO';

export class RehearsalRequestDTO {
    public performanceId: number = 0;
    public scenes: RehearsalSceneRequestDto[] = [];
    public purpose: string = '';
    public notes: string = '';
    public personName: string = '';
    public token: string | null = null;
}

